import { $api } from '@service/RequestService';
import { useMutation, useQueryClient } from 'react-query';

import { contractConstants, contractModels } from '..';

export const useBdmConfigSave = () => {
  const qc = useQueryClient();

  return useMutation(
    async (data: contractModels.IBdmConfig) => {
      const res = await $api.post('/v1/bdm/config', data);

      return res?.data;
    },
    {
      async onSuccess() {
        await qc.invalidateQueries([contractConstants.queryKeys.BDM_CONFIG]);
      }
    }
  );
};
